module.exports = __webpack_public_path__ + "static/media/sample-barcode.f649fa49.png";